
import { connect } from 'react-redux'

import { createNDATemplate, updateNDATemplate } from 'src/legacy/redux/actions/ndaTemplate.jsx';
import NDADetailsView from './view';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks';

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const templates = _.get(state.legacyRootReducer, "settings.ndaTemplates.items") || [];
  const template = templates.find(item => {
    return item.id === id
  });

  return {
    templates: templates,
    template: template,
    created: state.legacyRootReducer.settings.ndaTemplates.created,
    loading: state.legacyRootReducer.settings.ndaTemplates.loading,
    saving: state.legacyRootReducer.settings.ndaTemplates.creating || state.legacyRootReducer.settings.ndaTemplates.updating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createNDATemplate: (request) => {
      return dispatch(createNDATemplate(request));
    },

    updateNDATemplate: (id, request) => {
      return dispatch(updateNDATemplate(id, request));
    }
  }
}

const NDADetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NDADetailsView)

export default withUseHooks(NDADetailsContainer);